import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/arrowLeft.svg'
import _imports_1 from '@/assets/icons/svg/arrowRight.svg'
import _imports_2 from '@/assets/icons/svg/replay.svg'
import _imports_3 from '@/assets/icons/svg/trash.svg'
import _imports_4 from '@/assets/icons/svg/speaker-off.svg'
import _imports_5 from '@/assets/icons/svg/speaker.svg'
import _imports_6 from '@/assets/omar/worm-gla.svg'


const _withScopeId = n => (_pushScopeId("data-v-27224174"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full bg-gray-background relative" }
const _hoisted_2 = { class: "absolute z-10" }
const _hoisted_3 = { class: "m-4 flex flex-row" }
const _hoisted_4 = { class: "flex flex-row flex-grow justify-center mx-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_0,
  alt: "close"
}, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_1,
  alt: "close"
}, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_2,
  alt: "close"
}, null, -1 /* HOISTED */))
const _hoisted_8 = {
  key: 0,
  class: "absolute z-10 bottom-10 flex flex-col items-center rounded-2xl bg-white p-2 left-1/2 transform -translate-x-1/2",
  style: {"min-width":"50%"}
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "flex flex-row items-center" }
const _hoisted_11 = {
  key: 0,
  class: "relative h-12 w-full"
}
const _hoisted_12 = {
  key: 0,
  class: "w-6 h-6",
  src: _imports_4,
  alt: "close"
}
const _hoisted_13 = {
  key: 1,
  class: "w-6 h-6",
  src: _imports_5,
  alt: "close"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-24",
  src: _imports_6,
  alt: "close"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          ($setup.currentPageIndex > 0)
            ? (_openBlock(), _createBlock($setup["Button"], {
                key: 0,
                class: "pointer-events-auto ml-4 bg-white m-6",
                childclass: 'w-12 h-12',
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.prev()))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          ($setup.currentPageIndex < $setup.question.pages.length - 1)
            ? (_openBlock(), _createBlock($setup["Button"], {
                key: 1,
                class: "pointer-events-auto ml-4 bg-white m-6",
                childclass: 'w-12 h-12',
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.next()))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    ($setup.currentPageIndex === $setup.question.pages.length - 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "absolute z-20 bottom-10 w-full flex flex-row justify-end p-2 pr-10 pointer-events-none",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.stopPlaying()))
        }, [
          _createCommentVNode("Button\n        v-if=\"currentPageIndex > 0 && mode === MODES.tell\"\n        class=\"pointer-events-auto ml-4\"\n        :textcolour=\"'text-white'\"\n        :childclass=\"'text-2xl border-none p-5'\"\n        @click=\"again()\"\n        >{{ t('listenAgain') }}</Button\n      "),
          _createVNode($setup["Button"], {
            class: "pointer-events-auto bg-white mr-4",
            childclass: 'w-12 h-12',
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.again()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1 /* STABLE */
          }),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["Carousel"], {
      class: "h-full",
      onTouchstart: $setup.startTouch
    }, {
      addons: _withCtx(() => [
        _createVNode($setup["CarouselTrigger"], {
          ref: "carouselTriggerRef",
          onNewPage: $setup.newPage
        }, null, 512 /* NEED_PATCH */)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.question.pages, (page, index) => {
          return (_openBlock(), _createBlock($setup["Slide"], {
            key: `page-${index}`,
            index: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "relative w-screen h-screen bg-white bg-cover bg-center",
                style: _normalizeStyle({ backgroundImage: 'url(' + page.image + ')' })
              }, [
                _createCommentVNode("img class=\"w-full pointer-events-none\" :src=\"page.image\" alt=\"background image\" /"),
                ($setup.mode === $setup.MODES.retell)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
                      _createElementVNode("p", {
                        class: "m-1",
                        innerHTML: page.question
                      }, null, 8 /* PROPS */, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode($setup["RecordButton"], {
                          class: "mt-1 mr-6",
                          "recording-exists": $setup.recordingExists,
                          "is-playing": $setup.isPlaying,
                          onVclick: $setup.recordButtonClicked
                        }, null, 8 /* PROPS */, ["recording-exists", "is-playing"]),
                        ($setup.recordingExists)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "w-8 h-8",
                              src: _imports_3,
                              alt: "delete",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.deleteRecordedAudio()))
                            }))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 4 /* STYLE */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }),
    ($setup.mode === $setup.MODES.tell)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["absolute left-2 peek", $setup.omarActive ? 'bottom-0' : '-bottom-26'])
        }, [
          (!$setup.omarActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode($setup["Button"], {
                  class: "absolute pointer-events-auto bg-white rounded-full -bottom-3 -right-3",
                  childclass: 'w-12 h-12',
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.soundIsPlaying ? $setup.stopSounds() : $setup.activateOmar()))
                }, {
                  default: _withCtx(() => [
                    ($setup.soundIsPlaying)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                      : (_openBlock(), _createElementBlock("img", _hoisted_13))
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : _createCommentVNode("v-if", true),
          _hoisted_14
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}